__turbopack_context__.v({
  "ad-bottom-container": "index-module-scss-module__9ztcwG__ad-bottom-container",
  "ad-bottom__ad-id": "index-module-scss-module__9ztcwG__ad-bottom__ad-id",
  "ad-bottom__buttons": "index-module-scss-module__9ztcwG__ad-bottom__buttons",
});
